import { render, staticRenderFns } from "./CarList.vue?vue&type=template&id=54f20adc&scoped=true&"
import script from "./CarList.vue?vue&type=script&lang=js&"
export * from "./CarList.vue?vue&type=script&lang=js&"
import style0 from "./CarList.vue?vue&type=style&index=0&id=54f20adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f20adc",
  null
  
)

export default component.exports